import {
  FETCH_USER_TYPES,
  FETCH_USER_TYPES_SUCCESS,
  FETCH_USER_TYPES_FAILED,
  EDIT_USER_TYPE
} from "../store/types";

const INITIAL_STATE = {
  userstypes: {
    admin:"admin",
      broker:"broker",
      jnr_broker:"jnr_broker",
      bo_admin:"bo_admin",
      board_admin:"board_admin",
      broker_assistant:"broker_assistant",
      trainee_broker:"trainee_broker",
      corporate_broker:"corporate_broker",
      managing_partner:"managing_partner"
  },
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const usertypesreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_USER_TYPES:
      return {
        ...state,
        loading: true
      };
    case FETCH_USER_TYPES_SUCCESS:
      return {
        ...state,
        usertypes: action.payload,
        loading: false
      };
    case FETCH_USER_TYPES_FAILED:
      return {
        ...state,
        usertypes: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_USER_TYPE:
      return state;
    default:
      return state;
  }
};